
// constants
export const Breakpoints: ReadonlyArray<Breakpoint> = ["xs", "sm", "md", "lg", "xl"];


// types
export type Breakpoint = "xs" | "sm" | "md" | "lg" | "xl";
export type BreakpointObservation = Breakpoint | null;
